import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import { Box, Typography, Grid } from "@mui/material";
import "./Fee.css";
import NewFee from "../../../assests/images/feePicture1.png";
import HeadingContainer from "../../heading-container/HeadingContainer";

function FeeStructure() {
  const [feeData, setFeeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/feestructure`)
      .then(res => res.json())
      .then(data => {
        if (data && data.length > 0) {
          setFeeData(data[0]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching fee structure", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={{ backgroundColor: '#fcfcfc', minHeight: '80vh', paddingBottom: '60px' }}>
        <HeadingContainer title="Fee Structure" />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
             <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
             <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  const noticeDate = feeData?.noticeDate || "Not available";
  const prerequisites = feeData?.prerequisites || [];
  const conditions = feeData?.conditions || [];
  const docs = feeData?.documents || [];
  
  // Split documents into two columns for layout balance
  const splitIndex = Math.ceil(docs.length / 2);
  const docsPart1 = docs.slice(0, splitIndex);
  const docsPart2 = docs.slice(splitIndex);


  const importantNotes = feeData?.importantNotes || [];
  
  const feeClasses = feeData?.feeClasses || [];
  const feeAmounts = feeData?.feeAmounts || [];
  const maxTableRows = Math.max(feeClasses.length, feeAmounts.length);
  const tableRows = Array.from({ length: maxTableRows }).map((_, i) => ({
    cName: feeClasses[i] || "",
    cAmount: feeAmounts[i] || ""
  }));

  const instNames = feeData?.installmentNames || [];
  const instDates = feeData?.installmentDates || [];
  const maxInst = Math.max(instNames.length, instDates.length);
  const installmentRows = Array.from({ length: maxInst }).map((_, i) => ({
    name: instNames[i] || "",
    date: instDates[i] || ""
  }));

  return (
    <>
      <HeadingContainer title="Fee Structure" />
      <div className="fee-page-wrapper">
        <Container maxWidth="lg">
          <Typography variant="body1" className="fee-update-date">
            <b>Notice Updated:</b> {noticeDate}
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box className="fee-card hover-scale">
                <Typography variant="h5" className="fee-card-title text-gradient-primary">
                  Registration & Admission Policy
                </Typography>
                <div className="feeProcess">
                  <img src={NewFee} alt="Fee Process" />
                </div>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="fee-card hover-scale" sx={{ mb: 4 }}>
                <Typography variant="h5" className="fee-card-title text-gradient-primary" sx={{ mb: 2 }}>
                  Admission Prerequisites
                </Typography>
                <ul className="fee-list">
                  {prerequisites.map((item, idx) => (
                    <li key={idx} style={{ whiteSpace: 'pre-line' }}>{item}</li>
                  ))}
                  {prerequisites.length === 0 && <li>No prerequisites listed.</li>}
                </ul>
              </Box>

              <Box className="fee-card hover-scale">
                <Typography variant="h5" className="fee-card-title text-gradient-primary" sx={{ mb: 2 }}>
                  Important Conditions
                </Typography>
                <div className="fee-alert-box">
                  Admission is strictly subject to fulfilling all conditions and submission of requisite documents.
                </div>
                <ul className="fee-list">
                  {conditions.map((item, idx) => (
                    <li key={idx} style={{ whiteSpace: 'pre-line' }}>{item}</li>
                  ))}
                  {conditions.length === 0 && <li>No special conditions listed.</li>}
                </ul>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box className="fee-card hover-scale">
                <Typography variant="h5" className="fee-card-title text-gradient-primary" sx={{ mb: 2 }}>
                  Required Documents at Registration
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <ul className="fee-list">
                      {docsPart1.map((item, idx) => (
                        <li key={idx} style={{ whiteSpace: 'pre-line' }}>{item}</li>
                      ))}
                    </ul>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ul className="fee-list">
                      {docsPart2.map((item, idx) => (
                        <li key={`p2-${idx}`} style={{ whiteSpace: 'pre-line' }}>{item}</li>
                      ))}
                    </ul>
                  </Grid>
                  {docs.length === 0 && <Grid item xs={12}><p className="px-4">No specific documents listed.</p></Grid>}
                </Grid>
                <Typography variant="body2" sx={{ color: '#ef4444', fontStyle: 'italic', mt: 2, fontWeight: 600 }}>
                  Note: Incomplete or illegible Registration Forms, without photos will not be accepted.
                </Typography>
              </Box>

            </Grid>
            <Grid item xs={12} md={5}>
                <Box className="fee-card hover-scale" sx={{ height: '100%' }}>
                <Typography variant="h5" className="fee-card-title text-gradient-primary" sx={{ mb: 2 }}>
                  Installment Schedule
                </Typography>
                <ul className="fee-list installment-list">
                  {installmentRows.map((row, idx) => (
                       <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                           {row.name ? <span className="badge" style={{ margin: 0 }}>{row.name.trim()}</span> : null} 
                           <span style={{ fontWeight: 600 }}>{row.date.trim()}</span>
                       </li>
                  ))}
                  {installmentRows.length === 0 && <li>No installment schedule listed.</li>}
                </ul>

                <Typography variant="h6" sx={{ mt: 4, mb: 1, color: '#ef4444', fontWeight: 700 }}>Important Notes</Typography>
                <ul className="fee-list small-list">
                  {importantNotes.map((item, idx) => (
                    <li key={idx} style={{ whiteSpace: 'pre-line' }}>{item}</li>
                  ))}
                  {importantNotes.length === 0 && <li>No additional notes.</li>}
                </ul>
              </Box>
            </Grid>

            {/* Fee Table Section */}
            <Grid item xs={12} md={7}>
              <Box className="fee-card hover-scale" sx={{ height: '100%' }}>
                <Typography variant="h5" className="fee-card-title text-gradient-primary" sx={{ mb: 2 }}>
                  Fees Structure
                </Typography>
                <Typography variant="body1" sx={{ color: 'var(--text-muted)', mb: 3 }}>
                  Rules & Regulations Regarding School Fee
                </Typography>

                <div className="fee-table-container">
                  <table className="fee-modern-table">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Class</th>
                        <th className="amount-col">School Fee (Per Annum)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableRows.map((row, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td style={{ whiteSpace: 'pre-line' }}>{row.cName}</td>
                          <td className="amount-col" style={{ whiteSpace: 'pre-line' }}>{row.cAmount}</td>
                        </tr>
                      ))}
                      {tableRows.length === 0 && (
                        <tr>
                          <td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>Fee details not available.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Box>
            </Grid>

            
          </Grid>
        </Container>
      </div>
    </>
  );
}

export default FeeStructure;
